import { observer } from 'mobx-react-lite'
import React from 'react'
import { Link } from 'react-router'

// evertel
import { Modal, ModalBody, ModalHeader } from '@evertel/web/ui'
import { DocumentFullView } from '../DocumentFullView'

interface Props {
    visible?: boolean
    documentId: number
    onClose: () => void
    onEdit: (documentId: number) => void
}

const DocumentModal: React.FC<Props> = observer(({
    visible = false,
    documentId,
    onClose,
    onEdit
}) => {

    return (
        <Modal
            visible={visible}
            onClose={onClose}
            size="xl">
            <ModalHeader/>
            <ModalBody>
                <DocumentFullView
                    documentId={documentId}
                    onEdit={onEdit}
                    onDismiss={onClose}
                    nested
                />
                <Link to={`/everdocs/view/${documentId}`} style={{float: 'right'}}>View Full Screen</Link>
            </ModalBody>
        </Modal>
    )
})

export {
    DocumentModal
}
